import { useState, useRef, useEffect, Ref } from 'react'

export const useIsComponentVisible = (initialVisible = false, refToIgnore?: Ref) => {
    const [isComponentVisible, setIsComponentVisible] = useState(initialVisible)
    const ref = useRef<HTMLElement>(null)

    const handleHideDropdown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            setIsComponentVisible(false)
        }
    }

    const handleClickOutside = (event: Event) => {
        if (refToIgnore?.current && refToIgnore.current.contains(event.target)) return
        if (ref.current && !ref.current.contains(event.target as Node)) {
            setIsComponentVisible(false)
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleHideDropdown)
        document.addEventListener('click', handleClickOutside)
        document.addEventListener('touchstart', handleClickOutside)
        return () => {
            document.removeEventListener('keydown', handleHideDropdown)
            document.removeEventListener('click', handleClickOutside)
            document.removeEventListener('touchstart', handleClickOutside)
        }
    })

    return { ref, isComponentVisible, setIsComponentVisible }
}
